import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';

const LegalNotices = () => {
  return (
    <LegalLayout>
      <div className="container-standard px-4 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="flex justify-center items-center mb-6">
            <a href="/" className="text-primary-accent font-bold hover:underline text-lg">
                 ← Volver al Inicio
              </a>
            </div>
           <div className="text-center mb-4">
            <h1 className="text-display font-bold text-primary-dark">Avisos Legales</h1>
          </div>
          <div className="w-20 h-1 bg-primary-accent mx-auto mb-6"></div>
          <p className="text-body-lg text-gray-600 text-center">
            Información legal importante sobre el uso de nuestro sitio web y servicios
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
          {/* Terms and Conditions */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">⚖️</span>
              </div>
              <h2 className="text-heading font-bold text-primary-dark">Términos y Condiciones</h2>
            </div>
            
            <p className="text-gray-600 mb-6">
              Al acceder y utilizar este sitio web, usted acepta cumplir con los siguientes términos y condiciones.
            </p>
            
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>El contenido de este sitio web está protegido por derechos de autor y leyes de propiedad intelectual aplicables en el Perú.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>El uso del sitio web implica la aceptación expresa de estos términos y condiciones.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>DavidCorp S.R.L. se reserva el derecho de modificar estos términos en cualquier momento.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>El usuario es responsable del uso adecuado del sitio web y sus contenidos.</span>
              </li>
            </ul>
            
            <div className="mt-8 text-center">
              <Link 
                to="/terminos-y-condiciones" 
                className="inline-block bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
              >
                Leer más
              </Link>
            </div>
          </div>

          {/* Privacy Policy */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">🔒</span>
              </div>
              <h2 className="text-heading font-bold text-primary-dark">Política de Privacidad</h2>
            </div>
            
            <p className="text-gray-600 mb-6">
              Información sobre cómo recopilamos, usamos y protegemos sus datos personales.
            </p>
            
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Compromiso con la Ley de Protección de Datos Personales (Ley N° 29733).</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Uso exclusivo de la información para fines comerciales legítimos.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Implementación de medidas de seguridad para proteger sus datos.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición).</span>
              </li>
            </ul>
            
            <div className="mt-8 text-center">
              <Link 
                to="/privacidad" 
                className="inline-block bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
              >
                Leer más
              </Link>
            </div>
          </div>

          {/* Cookie Policy */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">🍪</span>
              </div>
              <h2 className="text-heading font-bold text-primary-dark">Política de Cookies</h2>
            </div>
            
            <p className="text-gray-600 mb-6">
              Información sobre el uso de cookies y tecnologías similares en nuestro sitio web.
            </p>
            
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Utilizamos cookies para mejorar la experiencia del usuario.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Las cookies nos ayudan a analizar el tráfico web y personalizar el contenido.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Puede configurar su navegador para rechazar cookies si lo desea.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>El uso continuado del sitio implica consentimiento para el uso de cookies.</span>
              </li>
            </ul>
            
            <div className="mt-8 text-center">
              <Link 
                to="/cookies" 
                className="inline-block bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
              >
                Leer más
              </Link>
            </div>
          </div>

          {/* Complaints Book */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center mr-4">
                <span className="text-2xl">📝</span>
              </div>
              <h2 className="text-heading font-bold text-primary-dark">Libro de Reclamaciones</h2>
            </div>
            
            <p className="text-gray-600 mb-6">
              Cumplimiento con la Ley N° 29587, Ley de Protección al Consumidor y su Reglamento.
            </p>
            
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Disponibilidad del Libro de Reclamaciones Virtual en cumplimiento con SUNAT.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Atención oportuna a todas las reclamaciones presentadas.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Compromiso con la resolución de conflictos de manera justa y eficiente.</span>
              </li>
              <li className="flex items-start">
                <span className="text-primary-accent mr-3 mt-1">•</span>
                <span>Resolución SBS N° 107-2023 para atención de reclamaciones financieras.</span>
              </li>
            </ul>
            
            <div className="mt-8 text-center">
              <Link 
                to="/libro-de-reclamaciones" 
                className="inline-block bg-primary-dark hover:bg-[#0d1c32] text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
              >
                Acceder al Libro
              </Link>
            </div>
          </div>
        </div>

        {/* Additional Legal Information */}
        <div className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-8 text-white">
          <h2 className="text-heading font-bold mb-6 text-center">Marco Legal Peruano</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🏛️</span>
              </div>
              <h3 className="font-semibold">Ley 29733</h3>
              <p className="text-sm opacity-80">Protección de Datos Personales</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">⚖️</span>
              </div>
              <h3 className="font-semibold">Ley 29587</h3>
              <p className="text-sm opacity-80">Protección al Consumidor</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🛡️</span>
              </div>
              <h3 className="font-semibold">Ley 30057</h3>
              <p className="text-sm opacity-80">Consumidores y Usuarios</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">📋</span>
              </div>
              <h3 className="font-semibold">SUNAT</h3>
              <p className="text-sm opacity-80">Obligaciones Comerciales</p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            DAVID CORPORATION S.R.L. - DAVIDCORP S.R.L.<br />
            RUC: 20602434011<br />
            491 Jr. Sta Cruz de Pachacutec, Los Olivos, Lima, Perú<br />
            Email: <a href="mailto:info@davidcorp-srl.com" className="text-primary-accent hover:underline">info@davidcorp-srl.com</a><br />
            Teléfono: <a href="tel:+51936776570" className="text-primary-accent hover:underline">+51 936776570</a>
          </p>
        </div>
      </div>
    </LegalLayout>
  );
};

export default LegalNotices;